<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-12">
                <div class="jumbotron screen-center mobile-bg-none mr-200" style="bottom: -50%; overflow-y: auto;">
                    <!-- display the newly created shop+ -->
                    <form v-if="displayShopName">
                        <div class="text-center">
                            <i class="fas fa-store fa-3x"></i>
                            <h3 class="my-3">{{displayShopName}}</h3>
                        </div>
                        <p class="text-center">
                            Congratulations on your upgrade to Shop+ <br> Cheers to all the new 
                            <router-link :to="{ name: 'seller-plans' }" tag="a" class="text-dark-green font-weight-bold">amazing benefits</router-link> 
                            you've just unlocked!
                        </p>
                        <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                            <i class="fas fa-exclamation-circle"></i> {{ msg }}
                        </div>
                        <hr class="my-4">
                        <div class="text-center mt-3">
                            <router-link :to="{ name: 'dashboard' }" tag="span" class="btn btn-dark-green ml-3">Access my Shop+</router-link>
                            <p class="text-dark-green text-center mt-5">
                                <router-link :to="{ name: 'home' }">&copy; aNewItem</router-link>
                            </p>
                        </div>
                    </form>

                    <!-- display to create a new shop+ -->
                    <form v-else>
                        <div class="text-center">
                            <i class="fas fa-store fa-3x"></i>
                            <h3 class="my-3">Welcome to sh<i class="far fa-smile fa-xs"></i>p+</h3>
                        </div>
                        <p class="text-center">
                            We are glad you made the decision to upgrade today! Shop+ automatically boosts your item sales by an additional 60%. 
                            <router-link :to="{ name: 'seller-plans' }" tag="a" class="text-dark-green font-weight-bold">Click me</router-link> 
                            to see all the great features you've just unlocked by choosing to upgrade - 
                            <router-link :to="{ name: 'home' }" class="text-dark-green font-weight-bold">aNewItem</router-link>
                        </p>
                        <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                            <i class="fas fa-exclamation-circle"></i> {{ msg }}
                        </div>
                        <hr class="my-4">
                        <dl class="row">
                            <dt class="col-md-3 col-sm-12 col-12">Shop Name:</dt>
                            <dd class="col-md-9 col-sm-12 col-12"><input v-model="shopName" type="text" ref="shopName"  class="form-control no-lines bg-white" required placeholder="business name"></dd>
                        </dl>
                        <dl v-if="user" class="row">
                            <dt class="col-md-3 col-sm-12 col-12">Shop Handle:</dt>
                            <dd class="col-md-9 col-sm-12 col-12">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">@</div>
                                    </div>
                                    <input type="text" :value="user.userHandle" readonly class="form-control no-lines bg-white text-dark-green" placeholder="unique handle">
                                </div>
                                <small class="text-center">(your handle is the same as your shop+ handle, to change your handle 
                                    <router-link :to="{name: 'settings', query: {handle: null}}" class="text-dark-green">click here</router-link>)
                                </small>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-md-3 col-sm-12 col-12">Create Passcode:</dt>
                            <dd class="col-md-4 col-sm-12 col-12"><input v-model="passcode" type="password" ref="passcode" class="form-control no-lines bg-white" required placeholder="passcode"></dd>
                            <dd class="col-md-5 col-sm-12 col-12"><input v-model="rePasscode" type="password" ref="rePasscode" class="form-control no-lines bg-white" required placeholder="re-passcode"></dd>
                        </dl>
                        <div class="text-right mobile-text-center mt-3">
                            <router-link :to="{ name: 'profile' }" tag="a" class="btn btn-light btn-lg">Cancel</router-link>
                            <button @click.prevent="createShopFxn" class="loadn btn btn-dark-green btn-lg ml-3">Create Shop+</button>
                            <p class="mt-4 text-muted text-center">
                                Already upgraded to shop+ ? Continue here to 
                                <router-link :to="{ name: 'lock-screen' }" tag="a" class="text-dark-green font-weight-bold">access your shop+</router-link>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import LayoutAuth from '@/layouts/Auth.vue'

export default {
    name: "CreateShop",
    data() {
        return {
            shopName: '',
            passcode: '',
            rePasscode: '',
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['createShop', 'completeCreateShop', 'createTransaction']),
        createShopFxn() {
            if(this.shopName === ''){ this.msg = "enter a name for your business"; return }
            if(this.passcode === ''){ this.msg = "create a strong passcode to secure your shop"; return }
            if(this.rePasscode === ''){ this.msg = "enter your passcode again to confirm"; return }
            if(this.passcode.length < 6){ this.msg = "strong passcodes are usually more than 5 characters"; return }
            if(this.passcode !== this.rePasscode){ this.msg = "your passcodes don't match! try again"; return }
            let shopObj = {
                shopName: this.shopName,
                passcode: this.passcode
            }
            /*
            *   temp store the shopObj in localStorage so after the payment gateway redirects 
            *   to this page we can use it to send the final api request to give user value for their money
            */
            localStorage.setItem('_s39cs25u', JSON.stringify(shopObj))
            
            // append the userId after localStorage, security reasons!
            shopObj.userId = this.user._id
            this.createShop(shopObj)
            .then((data) => {
                this.color = "success" 
                this.msg = data.msg
            }).catch((e) => {
                this.msg = "Sorry, we are unable to create your shop at this time. Try again!"
                this.passcode = ''
                this.rePasscode = ''
            })
        },
        completeNewShop(transactionId) {
            let shopPayload = JSON.parse(localStorage.getItem('_s39cs25u'))
            // very important! It stops the page from going into loop! Removed by vuex after payment validation
            if(!shopPayload) return
            let valueObj = {
                transactionId,
                userId: this.user._id,
                shopName: shopPayload.shopName,
                passcode: shopPayload.passcode,
            }
            this.completeCreateShop(valueObj) 
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                    this.passcode = ''
                    this.rePasscode = ''
                    // save transaction log for shop+
                    let eventObj = {
                        userId: this.user._id,
                        shopId: data.result._id,
                        event: `Shop+ upgrade - ${data.result.shopName} - successful!`
                    }
                    this.createTransaction(eventObj).then(() => {}).catch((e) => {})
                }
                this.msg = data.msg
            })
            .catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['user', 'userShop']),
        displayShopName() {
            if(this.$route.query.status && this.$route.query.status !== "successful"){
                return false
            }
            if(!this.$route.query.tx_ref || !this.$route.query.transaction_id){
                return false
            }
            if(this.user && this.userShop) {
                if(this.user.shopOwner) { 
                    return this.userShop.shopName
                }
            }
            return false
        }
    },
    created() {
        this.$emit('update:layout', LayoutAuth);
    },
    mounted() {
        if(this.$route.query.status && this.$route.query.status === "successful"){
            this.completeNewShop(this.$route.query.transaction_id)
        } else {
            // if payment was not successful remove the already stored complete...Obj from localStorage
            if(localStorage.getItem('_s39cs25u')){
                localStorage.removeItem('_s39cs25u')
            }
        }
    }
}
</script>